


























// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";

export default defineComponent({

	emits:[
		"input"
	],
	props:{
		value:{
			type:Boolean,
		},
		title:{
			type:String,
			default:""
		}
	},
	components:{
	},
	setup(props, context){
		

		const open = computed<boolean>({
			get:() => {
				return Boolean(props.value);
			},
			set:(v) => {
				context.emit("input", v);
			}
		});

		const toggle = () =>{
			open.value = !open.value;
		};

		return {
			open,
			toggle
		};
	}
});

